var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDrsecureOpen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.1128 13.833V3.83301C22.1128 3.14301 21.5528 2.58301 20.8628 2.58301C20.1728 2.58301 19.6128 3.14301 19.6128 3.83301V13.833C19.6128 14.523 20.1728 15.083 20.8628 15.083C21.5528 15.083 22.1128 14.523 22.1128 13.833Z",
    fill: "#73007D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.4144 8.04962L20.8627 5.60129L23.3127 8.04962C23.801 8.53796 24.5927 8.53796 25.081 8.04962C25.5677 7.56296 25.5677 6.76962 25.081 6.28296L21.7477 2.94962C21.2594 2.46129 20.4677 2.46129 19.9794 2.94962L16.646 6.28296C16.1577 6.76962 16.1577 7.56296 16.646 8.04962C17.1344 8.53796 17.926 8.53796 18.4144 8.04962Z",
    fill: "#73007D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.5428 19.7163L37.5428 14.7163C38.0295 14.2296 38.0295 13.4363 37.5428 12.9496C37.0545 12.4613 36.2628 12.4613 35.7745 12.9496L30.7745 17.9496C30.2861 18.4363 30.2861 19.2296 30.7745 19.7163C31.2628 20.2046 32.0545 20.2046 32.5428 19.7163Z",
    fill: "#73007D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.951 17.9496L5.95103 12.9496C5.46437 12.4613 4.67103 12.4613 4.18437 12.9496C3.69603 13.4363 3.69603 14.2296 4.18437 14.7163L9.18436 19.7163C9.67103 20.2046 10.4644 20.2046 10.951 19.7163C11.4394 19.2296 11.4394 18.4363 10.951 17.9496Z",
    fill: "#73007D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.2343 17.583V22.9997C24.2343 23.9197 23.4876 24.6663 22.5676 24.6663C21.5493 24.6663 20.2526 24.6663 19.2343 24.6663C18.3143 24.6663 17.5676 23.9197 17.5676 22.9997V17.583H10.0676C9.37763 17.583 8.81763 18.143 8.81763 18.833V37.1663C8.81763 37.8563 9.37763 38.4163 10.0676 38.4163H31.6576C32.3493 38.4163 32.9076 37.8563 32.9076 37.1663V18.833C32.9076 18.143 32.3493 17.583 31.6576 17.583H24.2343ZM15.0293 34.2497H18.3626C19.0526 34.2497 19.6126 33.6897 19.6126 32.9997C19.6126 32.3097 19.0526 31.7497 18.3626 31.7497H15.0293C14.3393 31.7497 13.7793 32.3097 13.7793 32.9997C13.7793 33.6897 14.3393 34.2497 15.0293 34.2497Z",
    fill: "#73007D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrsecureOpen);
export default __webpack_public_path__ + "static/media/drsecure_open.556f0e8cc47024f80dc2abdf18356bba.svg";
export { ForwardRef as ReactComponent };